module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedMediumItalic.ad758da.eot";